import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {Addition} from "../../models/addition.model";
import {TagsService} from "../../../tags/services/tags-service.service";
import {SubTasksService} from "../../../sub-tasks/services/sub-tasks-service.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class ProgramAdditionsViewCtrl implements IController {

  program: any;
  groups: any;
  programId: any;
  siteAdditions: Addition[];
  accountId: any;

  public groupValueCopy: any;
  public additions: any;
  public groupValue: any;
  public additionsValueMap: any;
  public isSaveAvailable: any;

  /* @ngInject */
  constructor(private PricePlanService, private pricePlanDialogService: PricePlanDialogService, private $q: IQService,
              private subTasksService: SubTasksService, private tagsService: TagsService, private tagsConstants, private $log) {
  }

  $onInit() {
    this.additions = [];
    this.additionsValueMap = {};
    this._setGroupValue();
  }

  onAddAddition($event) {
    const additionIds = _.map(this.groupValue, 'id');
    this.pricePlanDialogService.selectAddition(additionIds, $event)
      .then((selectedAdditions) => {
        const values = this.PricePlanService.getAdditionsGroups(selectedAdditions);
        this.groupValue = this.groupValue.concat(values);
        this.onSaveProgram(selectedAdditions);

      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteAddition(addition) {
    this.groupValue = _.filter(this.groupValue, (v) => {
      return v.id !== addition.id;
    })
    this.onSaveProgram();
  }

  onStateChange(id, isEnabled) {
    const additionValueRef = _.find(this.groupValue, (v) => {
      return v.id === id;
    })
    if (additionValueRef) {

      if (_.isUndefined(isEnabled)) {
        _.unset(additionValueRef, 'value.enabled');
      } else {
        if (!additionValueRef.value) {
          additionValueRef.value = {};
        }
        additionValueRef.value.enabled = isEnabled;
      }

    }
    this.additionsValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onAdditionPriceChange(price, addition) {
    const additionValueRef = _.find(this.groupValue, (v) => {
      return v.id === addition.id
    })
    if (additionValueRef) {

      if (_.isUndefined(price)) {
        _.unset(additionValueRef, 'value.price');
      } else {
        if (!additionValueRef.value) {
          additionValueRef.value = {};
        }
        additionValueRef.value.price = price;
      }
    }
    this.additionsValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onSaveProgram(additionsAdded?) {
    const editedProgram = angular.copy(this.program);
    editedProgram.data[0].value = this.groupValue;
    this.PricePlanService.saveProgramDataByGroups(this.programId, editedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;

        if (additionsAdded && additionsAdded.length) {
          this._setGroupValue();
        }
      })
      .catch((error) => {
        this.$log.error('Failed to update program', error)
      })
      .finally(() => {
        this._setGroupValue();
      })
  }

  private _setGroupValue() {
    this.isSaveAvailable = false;
    this.groupValue = angular.copy(this.program.data[0].value);
    this.groupValueCopy = angular.copy(this.groupValue);
    this.additionsValueMap = _.keyBy(this.groupValue, 'id');

    // this.additions = _.map(this.groupValue, 'value');
    // const additionIds = _.map(this.groupValue, 'value.id');
    // this.additions = _.filter(this.siteAdditions, (a) => {
    //   return _.includes(additionIds, a.id);
    // })

    const additions = [];

    _.forEach(this.groupValue, (groupValue) => {
      const addition = groupValue.value || groupValue.parentValue;

      if (!addition.id) {
        addition.id = _.get(groupValue, 'parentValue.id');
      }

      const ref = _.find(this.siteAdditions, (siteAddition) => {
        return groupValue.id === siteAddition.id;
      })

      if (!!ref) {
        addition.name = ref.name;
        addition.type = ref.type;
        addition.description = ref.description;
        addition.visibleByAgent = ref.visibleByAgent;
      }

      additions.push(addition);
    })

    this.additions = additions;
  }

  private _onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.groupValue, this.groupValueCopy);
  }

  onCancelChanges(){
    this._setGroupValue();
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programAdditionsView', {
    bindings : {
      program: '<',
      groups: '<',
      programId: '<',
      siteAdditions: '<?',
      accountId: '<?'
    },
    template: require('./program-additions-view.html').default,
    controller : ProgramAdditionsViewCtrl
  });
